import { useContext } from "react";
import { Stack, Button, Card } from "react-bootstrap";
import { custom_context } from "@/utils/custom_context";
import { renderRejectionMessage } from "../utils";
import { BusinessKYCModalLayout } from "@/components/Modal";

import StatusTag from "@/components/Common/StatusTag";
import { STATUS_MAP } from "@/utils/constant";

import '../dashboard_styles.css';

function KycCard({ loanDetails, kycDetails, refreshStatus }) {
  const { showKycModal, setShowKycModal } = useContext(custom_context.ModalContext);
  const { current_status, rejection_reason } = kycDetails || {};
  const { status, description: rejectReason } = current_status || {};
  let description = "Receive a tailored credit limit offer and start uploading invoices"

  const stepComplete = status === STATUS_MAP.completed.value;
  const showAction = true;
  let actionButton = 'UPDATE';

  if (status === 'verified') {
    actionButton = 'VIEW';
    description = "We've successfully verified your kyc details."
  } else if (!!status) {
    description = "You can click Update to modify and resubmit correct details."
  } else {
    description = "Please complete your KYC to continue."
  }

  return (
    <Card className={`dashboardActionCard activeCard`} data-testid="fincobox-los-kyc-card">
      <Stack direction="horizontal" gap={3}>
        <Stack gap={2} className="actionContent">
          <h4 className="actionCardTitle dash_statusDiv" data-testid="fincobox-los-kyc-heading">
            KYC
            {status && (
              <> Status <StatusTag
                status={status}
                stepComplete={stepComplete}
                label={STATUS_MAP[status]?.label || "Unknown"}
                data-testid="fincobox-los-kyc-status"
              /></>
            )}
          </h4>
          <p className="actionCardDescription" data-testid="fincobox-los-kyc-description">{['input_required', 'rejected'].includes(status) ? rejectReason : description}</p>
        </Stack>
        {
          showAction && <div>
            <Button
              variant="primary"
              onClick={() => setShowKycModal(true)}
              className="actionButton"
              color="primary"
              data-testid="fincobox-los-kyc-action-btn"
              data-action={actionButton.toLowerCase()}
            >
              {actionButton}
            </Button>
          </div>
        }
      </Stack>
      {renderRejectionMessage(status, rejection_reason)}
      {showKycModal && <BusinessKYCModalLayout show={showKycModal} setShow={setShowKycModal} onClose={refreshStatus} loanDetails={loanDetails} />}
    </Card >
  );
}

export default KycCard;
